<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>

<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar id="conduction1" class="jk-batch-toolbar">
      <button class="btn btn-primary" (click)="doRunSelectedAction()">
        <mat-icon fontIcon="play_arrow"></mat-icon>執行
      </button>
      <button class="btn btn-secondary" (click)="doGetPreFilter()">
        <mat-icon fontIcon="history"></mat-icon>取前次
      </button>
    </mat-toolbar>

    <div class="jk-grid-cols-2">
      <app-jkcombobox label="執行項目" [(value)]="batchAction" [items]="batchActionList" style="width:400px;" >
      </app-jkcombobox>
      <div>
        <app-jkcombobox label="資料頻率" [(value)]="pageOpt.stklg002" [items]="stklg002List">
        </app-jkcombobox>
      </div>
      <div>
        <app-jkcombobox label="股票群組" [(value)]="pageOpt.groupId" [items]="candleGroupList"
          [canSpace]="true" [showClearButton]="true">
        </app-jkcombobox>

      </div>
      <div>
        <app-jkdaterange label="交易日期" [(valueA)]="pageOpt.date1" [(valueB)]="pageOpt.date2"
          [showClearButton]="true">
        </app-jkdaterange>
      </div>
    </div>

    <div class="jk-grid-cols-3">
      <div>
        <app-jkcombobox label="K線頻率" [(value)]="pageOpt.kLineType" [canSpace]="true" [items]="kLineTypeList"
          [showClearButton]="true">
        </app-jkcombobox>
      </div>
      <div>
        <app-jkcombobox label="日盤/AM盤" [(value)]="pageOpt.tradeSession" [canSpace]="true"
          [items]="tradeSessionList" [showClearButton]="true">
        </app-jkcombobox>
      </div>
      <div>
        <app-jkcheckbox label="重計選股中心(calcSTKMJ)" [(value)]="pageOpt.calcSTKMJ">
        </app-jkcheckbox>
        <app-jkcheckbox label="重計技術分析(calcOneDay)" [(value)]="pageOpt.calcOneDay">
        </app-jkcheckbox>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="玉山證券歷史K線維護">
    <mat-toolbar class="h-9">
      <button class="btn" [class.btn-primary]="true" (click)="getCandles()" [disabled]="isBusy">
        <mat-icon fontIcon="search"></mat-icon>執行
      </button>
      <button class="btn" [class.btn-secondary]="true" (click)="doGetPreFilter()">
        <mat-icon fontIcon="history"></mat-icon>取前次
      </button>
    </mat-toolbar>

    <div class="jk-grid-cols-3">
      <div>
        <app-jkdaterange label="日期" [(valueA)]="pageOpt.dateA" [(valueB)]="pageOpt.dateB"
          [showClearButton]="true">
        </app-jkdaterange>
      </div>
      <div>
        <app-jkcombobox label="商品類型" [(value)]="pageOpt.candleType" [items]="candleTypeList">
        </app-jkcombobox>
      </div>
      <div>
        <app-jkcombobox label="Ｋ線週期" [(value)]="pageOpt.candleTimeframe" [items]="candleTimeframeList">
        </app-jkcombobox>
      </div>
      <div>
        <app-jkcombobox label="股票群組" [(value)]="pageOpt.candleGroupNo" [items]="candleGroupList"
          [canSpace]="true" [showClearButton]="true">
        </app-jkcombobox>
        <button class="btn" [class.btn-second]="true" (click)="doAddGroupStocks()" [disabled]="isBusy">
          <mat-icon fontIcon="add"></mat-icon>加入股票代號
        </button>
        <button class="btn" [class.btn-second]="true" (click)="getCandlesGroup(pageOpt.candleGroupNo)" [disabled]="isBusy">
          <mat-icon fontIcon="add"></mat-icon>群組K線資料
        </button>
      </div>
    </div>

    <div>
      <app-jktextarea label="股票代號多選" [rows]="6" name="candleSymbolList" class="w-full"
        [(value)]="pageOpt.candleSymbolList" [autoResizeEnabled]="true" [minHeight]="120" [maxHeight]="260">
      </app-jktextarea>
    </div>

    <div>
      <app-jktextarea label="執行結果" [rows]="8" name="candleMessage" class="w-full"
        [(value)]="pageOpt.candleMessage" [autoResizeEnabled]="true" [minHeight]="160" [maxHeight]="420">
      </app-jktextarea>
    </div>
  </mat-tab>

  <mat-tab #myTabResult label="執行結果">
    <div>
      <app-jktextarea label="PS" [rows]="3" name="comment" id="comment" class="w-full" [required]="true"
        [(value)]="logMessage" [autoResizeEnabled]="true" [minHeight]="60" [maxHeight]="400">
      </app-jktextarea>
    </div>
  </mat-tab>
</mat-tab-group>
